import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import Config from 'constants/Config';

import { Logger } from 'PMT/utils';
import Listener from 'PMT/flux/Listener';
import SdkConfiguration from 'PMT/utils/SdkConfiguration';

import { Events } from 'constants';
import RoutingEnum from 'constants/RoutingEnum';
import appHistory from '../history';

import { RestaurantAction, ProAccountAction } from 'actions';

// -- stores
import { RestaurantStore, ProAccountStore, SessionStore, RouteStore } from 'stores';

// -- views
import Header from 'components/header/Header';
import Sidebar from 'components/sidebar/Sidebar';
import { AbstractComponent, Footer } from 'components';
// import { Footer } from 'components/footer';
import ContactModal from 'components/modal/ContactModal';

/**
 * @parent index.js
 */
class Layout extends AbstractComponent {

  static propTypes = {};

  redirectAfterAccountLoad = false;

  state = {
    displayContactModal: false,

    /**
     * The current selected restaurant.
     */
    restaurant: null,

    /**
     * The current user's account.
     */
    meAccount: null,

    /**
     * Is set to true to allow us to reload the whole Layout.
     * Used when we change the restaurant.
     */
    reloadingLayout: false,
  };

  componentWillMount() {
    SdkConfiguration.setDomainUrl(`https://${Config.HOSTNAME}`);
  }

  componentDidMount() {
    RestaurantStore.addListeners(this.restaurantListeners);
    ProAccountStore.addListeners(this.proAccountListeners);

    SessionStore.addListener(Events.ON_LOGIN_SUCCESS, this.onLogin);

    if (SessionStore.isLoggedIn()
        && appHistory.location.pathname === RoutingEnum.LOGIN.path) {
      this.onLogin();
    } else {
      this.loadAccount();
    }
  }

  componentWillUnmount() {
    RestaurantStore.removeListeners(this.restaurantListeners);
    ProAccountStore.removeListeners(this.proAccountListeners);

    SessionStore.removeListener(Events.ON_LOGIN_SUCCESS, this.onLogin);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  loadAccount = () => {
    if (SessionStore.isLoggedIn()) {
      // Clear any previous session's layout before child pages can mount.
      this.setState({
        loading: true,
        restaurant: null,
        meAccount: null,
        apiError: null,
      }, () => ProAccountAction.retrieveMeAccount());
    }
  };

  onLogin = () => {
    const nextLocation = RouteStore.getPostLoginLocation();
    // Only /redirect must run before account loading to apply the incoming context.
    if (nextLocation && nextLocation.pathname === RoutingEnum.REDIRECT_PAGE.path) {
      this.redirectAfterAccountLoad = false;
      RouteStore.redirectAfterLogin();
      return;
    }
    this.redirectAfterAccountLoad = true;
    this.loadAccount();
  };

  //
  // Listeners
  //

  get restaurantListeners(): Array<Listener> {
    return [
      new Listener(Events.LOAD_RESTAURANT_SUCCESS, this.onRestaurantChange),
      new Listener(Events.UPDATE_RESTAURANT_SUCCESS, this.onRestaurantChange),
      new Listener(Events.RESTAURANT_CHANGE_SUCCESS, this.onRestaurantGroupChange),
      new Listener(Events.RESTAURANT_CHANGE_REQUEST, this.onRestaurantIsChanging),
    ];
  }

  get proAccountListeners(): Array<Listener> {
    return [
      new Listener(Events.PRO_ACCOUNT_GET_ME_SUCCESS, this.onLoadMe),
      new Listener(Events.PRO_ACCOUNT_GET_ME_FAILURE, this.onLoadMeError)
    ];
  }

  //
  // Events
  //

  onLoadMe = () => {
    try {
      // Navigate while child pages are still blocked; stores now contain the account.
      if (this.redirectAfterAccountLoad) {
        this.redirectAfterAccountLoad = false;
        RouteStore.redirectAfterLogin();
      }
      this.setState({
        restaurant: RestaurantStore.getRestaurant(),
        meAccount: ProAccountStore.getMeAccount(),
        loading: false,
      });
    } catch (e) { console.error(e); }
  };

  onLoadMeError = () => {
    this.setState({
      loading: false,
      apiError: ProAccountStore.getApiError(),
    });
  };

  /**
   * The selected restaurant is changing.
   * In order to avoid errors, we reload the layout.
   */
  onRestaurantIsChanging = () => {
    this.setState({
      reloadingLayout: true
    });
  }

  /**
   * Triggered when the user have changed the selected restaurant / restaurantsGroup
   * we have to reload the whole page.
   */
  onRestaurantGroupChange = () => {
    window.location.reload()
  };

  onRestaurantChange = () => {
    this.setState({
      restaurant: RestaurantStore.getRestaurant(),

      // wait for the other api call that retrieve the account
      loading: _.isNull(this.state.meAccount)
    });
  };

  //
  // events - contact modal
  //

  onDisplayContactModal = () => {
    this.setState({
      displayContactModal: true
    });
  };

  onHideContactModal = () => {
    this.setState({
      displayContactModal: false
    });
  };

  //
  // renderers
  //

  renderSidebar() {
    if (!SessionStore.isLoggedIn()) {
      return (null);
    }

    return (
      <Sidebar
          routes={this.props.children}
      />
    );
  }

  renderLayout() {
    if (this.state.apiError) {
      return this.renderApiErrorBlock();
    }
    if (SessionStore.isLoggedIn()) {
      if (this.state.reloadingLayout === true
      || _.isNull(this.state.meAccount)
      || _.isNull(this.state.restaurant)
    ) {
        return this.renderOnLoadingContent();
      }
    }

    return (
      <div>
        <Header
          onDisplayContactModal={this.onDisplayContactModal}
          routes={this.props.children}
        />

        <div className="container-fluid">
          <div className="row">

            <div className="col-sm-2 sidebar">
              {this.renderSidebar()}
            </div>

            <div id="page_wrapper" className="col-md-12 col-lg-10 col-lg-offset-2 main">
              {this.props.children}
            </div>

            {/* <Footer /> */}
          </div>

          <ContactModal
            show={this.state.displayContactModal}
            onHide={this.onHideContactModal}
          />

        </div>
      </div>
    );
  }

  render() {
    /**
    * Render the layout of our page. If an exception occured, we log it and send it to our tracker.
    */
    return (
      <div>
        {this.renderLoading()}
        {this.renderLayout()}
      </div>
    );

  }
}

export default Layout;
